module.exports = require("./wae.d.ts");